import React, { useEffect } from 'react';
import { useGym } from '../../DataStore/Gym/GymContext';
import { Link } from 'react-router-dom';
import ActivityLoader from '../Common/ActivityLoader';
import Notification from '../Common/Notification';

const GymActivity = () => {
  const { getDailySessionActivity, dailySessionActivity } = useGym();

  useEffect(() => {
    getDailySessionActivity();
  }, []);

  const getBadgeColor = (status) => {
    switch (status) {
      case 'active':
        return 'success';
      case 'completed':
        return 'danger';
      default:
        return 'primary';
    }
  };

  const formatTime = (datetime) => {
    const time = new Date(datetime);
    return time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
  };

  return (
    <div className="main-card mb-3 card">

       <div className="card-header card-title">Today's Gym Activity
          <div className="btn-actions-pane-right actions-icon-btn">
                <Link to="/gym-finder" className='btn-pill btn btn-outline-primary btn-sm'>New Session</Link>
            </div>
      </div>

      <div className="card-body">
        <div className="vertical-timeline vertical-timeline--animate vertical-timeline--one-column overflow-auto" style={{ maxHeight: '263px', minHeight: '263px' }}>
          {Array.isArray(dailySessionActivity) && dailySessionActivity.map((session) => {
            const isClass = typeof session.class_schedule_id === 'object' && session.class_schedule_id !== null;
            const title = isClass
              ? `${session.class_schedule_id.class.class_name} (Class)`
              : `Walk-in Session`;
            const description = isClass
              ? session.class_schedule_id.class.description
              : session.session_type;
            const time = formatTime(session.session_start);

            return (
              <div className="vertical-timeline-item vertical-timeline-element" key={session.id}>
                <div>
                  <span className="vertical-timeline-element-icon bounce-in">
                    <i className={`badge badge-dot badge-dot-xl badge-${getBadgeColor(session.status)}`}> </i>
                  </span>

                  <div className="vertical-timeline-element-content bounce-in">
                    <h5 className="timeline-title mb-1">{title}</h5>
                    <p className="mb-1 text-muted">
                      <strong>{session.member.full_name}</strong> &nbsp;
                      <small>{session.member.phone_number}</small>
                    </p>
                    <p className="mb-2">{description}</p>
                    <span className="vertical-timeline-element-date font-weight-normal text-muted">{time}</span>
                  </div>
                </div>
              </div>
            );
          })}
          {!dailySessionActivity && <ActivityLoader />}
          {dailySessionActivity === "404" && <Notification message="No Gym Activity today. Click on New Activity to get started." closable={false}/>}
        </div>

      </div>
    </div>
  );
};

export default GymActivity;
